// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"2be906db","388":"f1d21ac7","415":"749770f6","453":"793684db","574":"f447a70d","581":"8f363265","667":"53335569","668":"8601fd50"}[chunkId] + ".chunk.js";
};